const state = {
  foo: 1,
};

const mutations = {};

const actions = {
  async socket_connect() {
    // Acknowledge backend we are interested in insurance events
    this._vm.$socket.emit('insuranceSubscribe', {});
    // Register at least one handler so backend will start sending events to this client
    this._vm.$socket.addEventListener('insuranceSubscribe');
  },

  socket_insuranceSubscribe({ rootState, dispatch, commit }, payload) {
    if (
      payload.type === 'EmployeeSignsOut' &&
      payload.meta.employeeId === rootState.auth.currentUser.id
    ) {
      dispatch('logout');
    }
    if (payload.type === 'InsuranceCreated') {
      commit('updateCountersMutation', {
        ...rootState.stat.counters,
        new: Number(rootState.stat.counters.insurance.new) + 1,
      });
    }

    if (payload.type === 'InsuranceAccepted') {
      const patch = {
        new: Number(rootState.stat.counters.insurance.new) - 1,
        accepted: Number(rootState.stat.counters.insurance.accepted) + 1,
      };
      commit('updateCountersMutation', {
        ...rootState.stat.counters,
        insurance: {
          ...rootState.stat.counters.insurance,
          ...patch,
        },
      });
    }
    if (payload.type === 'InsuranceTerminated') {
      // Contract may become terminated both from "new" and "accepted".
      // Here we do not know previos status of insurance that has been terminated.
      // Fetching counters with separate HTTP request
      dispatch('updateCounters');
    }
  },
};

export default {
  state,
  mutations,
  actions,
};
